import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    createMaterialRes: null,
    getAllMaterialsRes: null,
    getMaterialByIdRes: null,
    updateMaterialRes: null,
    enterResultRes: null,
    getResultsRes: null,
    reviewResultRes: null,
    leveyJenningsRes: null,
    summaryRes: null,
};

const slice = createSlice({
    name: 'labQC',
    initialState,
    reducers: {
        createQCMaterialRequest: (state) => { state.loading = true; },
        createQCMaterialSuccess: (state, action) => { state.loading = false; state.createMaterialRes = action.payload; },
        createQCMaterialFailure: (state, action) => { state.loading = false; state.createMaterialRes = action.payload; },
        resetCreateQCMaterial: (state) => { state.createMaterialRes = null; },

        getAllQCMaterialsRequest: (state) => { state.loading = true; },
        getAllQCMaterialsSuccess: (state, action) => { state.loading = false; state.getAllMaterialsRes = action.payload; },
        getAllQCMaterialsFailure: (state, action) => { state.loading = false; state.getAllMaterialsRes = action.payload; },
        resetGetAllQCMaterials: (state) => { state.getAllMaterialsRes = null; },

        getQCMaterialByIdRequest: (state) => { state.loading = true; },
        getQCMaterialByIdSuccess: (state, action) => { state.loading = false; state.getMaterialByIdRes = action.payload; },
        getQCMaterialByIdFailure: (state, action) => { state.loading = false; state.getMaterialByIdRes = action.payload; },
        resetGetQCMaterialById: (state) => { state.getMaterialByIdRes = null; },

        updateQCMaterialRequest: (state) => { state.loading = true; },
        updateQCMaterialSuccess: (state, action) => { state.loading = false; state.updateMaterialRes = action.payload; },
        updateQCMaterialFailure: (state, action) => { state.loading = false; state.updateMaterialRes = action.payload; },
        resetUpdateQCMaterial: (state) => { state.updateMaterialRes = null; },

        enterQCResultRequest: (state) => { state.loading = true; },
        enterQCResultSuccess: (state, action) => { state.loading = false; state.enterResultRes = action.payload; },
        enterQCResultFailure: (state, action) => { state.loading = false; state.enterResultRes = action.payload; },
        resetEnterQCResult: (state) => { state.enterResultRes = null; },

        getQCResultsRequest: (state) => { state.loading = true; },
        getQCResultsSuccess: (state, action) => { state.loading = false; state.getResultsRes = action.payload; },
        getQCResultsFailure: (state, action) => { state.loading = false; state.getResultsRes = action.payload; },
        resetGetQCResults: (state) => { state.getResultsRes = null; },

        reviewQCResultRequest: (state) => { state.loading = true; },
        reviewQCResultSuccess: (state, action) => { state.loading = false; state.reviewResultRes = action.payload; },
        reviewQCResultFailure: (state, action) => { state.loading = false; state.reviewResultRes = action.payload; },
        resetReviewQCResult: (state) => { state.reviewResultRes = null; },

        getLeveyJenningsRequest: (state) => { state.loading = true; },
        getLeveyJenningsSuccess: (state, action) => { state.loading = false; state.leveyJenningsRes = action.payload; },
        getLeveyJenningsFailure: (state, action) => { state.loading = false; state.leveyJenningsRes = action.payload; },
        resetGetLeveyJennings: (state) => { state.leveyJenningsRes = null; },

        getQCSummaryRequest: (state) => { state.loading = true; },
        getQCSummarySuccess: (state, action) => { state.loading = false; state.summaryRes = action.payload; },
        getQCSummaryFailure: (state, action) => { state.loading = false; state.summaryRes = action.payload; },
        resetGetQCSummary: (state) => { state.summaryRes = null; },
    }
});

export const {
    createQCMaterialRequest, createQCMaterialSuccess, createQCMaterialFailure, resetCreateQCMaterial,
    getAllQCMaterialsRequest, getAllQCMaterialsSuccess, getAllQCMaterialsFailure, resetGetAllQCMaterials,
    getQCMaterialByIdRequest, getQCMaterialByIdSuccess, getQCMaterialByIdFailure, resetGetQCMaterialById,
    updateQCMaterialRequest, updateQCMaterialSuccess, updateQCMaterialFailure, resetUpdateQCMaterial,
    enterQCResultRequest, enterQCResultSuccess, enterQCResultFailure, resetEnterQCResult,
    getQCResultsRequest, getQCResultsSuccess, getQCResultsFailure, resetGetQCResults,
    reviewQCResultRequest, reviewQCResultSuccess, reviewQCResultFailure, resetReviewQCResult,
    getLeveyJenningsRequest, getLeveyJenningsSuccess, getLeveyJenningsFailure, resetGetLeveyJennings,
    getQCSummaryRequest, getQCSummarySuccess, getQCSummaryFailure, resetGetQCSummary,
} = slice.actions;

export default slice.reducer;
